const actions = {
    GET_PLAN_PRICE_CONFIG_LIST: "GET_PLAN_PRICE_CONFIG_LIST",
    GET_PLAN_PRICE_CONFIG_LIST_SUCCESS: "GET_PLAN_PRICE_CONFIG_LIST_SUCCESS",
    GET_PLAN_PRICE_CONFIG_LIST_FAILED: "GET_PLAN_PRICE_CONFIG_LIST_FAILED",

    RESET_MESSAGE: "RESET_MESSAGE",

    UPDATE_PLAN_PRICE_CONFIG: "UPDATE_PLAN_PRICE_CONFIG",
    UPDATE_PLAN_PRICE_CONFIG_SUCCESS: "UPDATE_PLAN_PRICE_CONFIG_SUCCESS",
    UPDATE_PLAN_PRICE_CONFIG_FAILED: "UPDATE_PLAN_PRICE_CONFIG_FAILED",

    UPDATE_SIMSwap_PRICE_CONFIG: "UPDATE_SIMSwap_PRICE_CONFIG",
   

    getPlanPriceConfigList: (data) => ({
        type: actions.GET_PLAN_PRICE_CONFIG_LIST,
        payload: { data },
    }),

    getPlanPriceConfigListSuccess: (data) => ({
        type: actions.GET_PLAN_PRICE_CONFIG_LIST_SUCCESS,
        payload: { data },
    }),

    getPlanPriceConfigListError: (error) => ({
        type: actions.GET_PLAN_PRICE_CONFIG_LIST_FAILED,
        error,
    }),


    updatePlanPriceConfig: (data) => ({
        type: actions.UPDATE_PLAN_PRICE_CONFIG,
        payload: { data },
    }),
    updateSIMSwapPriceConfig:(data) => ({
          type: actions.UPDATE_SIMSwap_PRICE_CONFIG,
        payload: { data },
    }),

    updatePlanPriceConfigSuccess: (message) => ({
        type: actions.UPDATE_PLAN_PRICE_CONFIG_SUCCESS,
        payload: { message },
    }),

    updatePlanPriceConfigError: (error) => ({
        type: actions.UPDATE_PLAN_PRICE_CONFIG_FAILED,
        error,
    }),

    resetMessage: () => ({
        type: actions.RESET_MESSAGE,
    }),


};

export default actions;